import { IonButton, IonInput, IonLabel, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";
import Loader from "../../../../../../../../components/Shared/Loader/Loader";
import NoResults from "../../../../../../../../components/Shared/NoResults/NoResultsComponent";
import TimePicker from "../../../../../../../../components/Shared/TimePicker/timepicker-component";
import { utilService } from "../../../../../../../../services/utilService";
import { statusBoardService } from "../../../../../../StatusBoard.service";
import {
  displayReminderContainerModel,
  RespReminderInterface,
} from "./Models/Reminder.model";
import { useToast } from "@agney/ir-toast";
import "./Reminder.scss";
import { reminderService } from "./Reminder.service";
import { reminderCardParams } from "./Components/ReminderCard/Models/ReminderCard.model";
import ReminderCard from "./Components/ReminderCard/ReminderCard";
import classNames from "classnames/bind";
import { ReminderAlertService } from "../../../../../../../../services/ReminderAlert.service";
import _ from "lodash";
import { statusBoardSocketService } from "../../../../../../StatusBoardSocketService";
import moment from "moment";
import { useTranslation } from "react-i18next";
interface ContainerProps {
  isReminderUpdated: boolean;
  onReminderUpdated: () => void;
}

const Reminder: React.FC<ContainerProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  var [bedID, setBedID]: any = useState([]);
  var [statusBoardID, setStatusBoardID]: any = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showTimePickerModal, setTimePickerModal] = useState(false);
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [reminderData, setReminderData]: any = useState([]);
  const [textData, setTextData]: any = useState("");
  const [disableAddButton, setDisableAddButton] = useState(true);
  const [selectedTime, setSelectedTime] = useState<any>(utilService.getFormattedCurrentTime());
  const Toast = useToast();
  useEffect(() => {
    setBedID(statusBoardService.rowData.id);
    setStatusBoardID(statusBoardService.statusBoardId);
    getReminderListDetails();
  }, []);

  useEffect(() => {
    if (props.isReminderUpdated) {
      getReminderListDetails();
      props.onReminderUpdated();
    }
  }, [props.isReminderUpdated]);

  useEffect(() => {
    const isWhitespace = (textData || "").trim().length === 0;
    if (isWhitespace) {
      setDisableAddButton(true);
    } else {
      setDisableAddButton(false);
    }
  }, [textData]);

  async function getReminderListDetails() {
    setLoaderStatus(true);
    const params: any = getReminderParams();
    const respReminderResult: RespReminderInterface =
      await reminderService.getReminderList(params);
    if (respReminderResult.isSuccess) {
      const isUserAssignedToPatient = isAssignedNurse();
      setReminderData(respReminderResult.displayReminderContainer);
      if (isUserAssignedToPatient) {
        ReminderAlertService.reminderListUpdate(
          respReminderResult.displayReminderContainer
        );
      }
    } else {
      reminderService.handleErrorResponse();
    }
    setLoaderStatus(false);
  }

  async function submitReminderCardListDetails(params: reminderCardParams) {
    const respReminderCardResult: any =
      await reminderService.getReminderCardList(params);
    if (respReminderCardResult.isSuccess) {
      const isUserAssignedToPatient = isAssignedNurse();
      setReminderData(respReminderCardResult.displayReminderContainer);
      if (isUserAssignedToPatient) {
        ReminderAlertService.reminderListUpdate(
          respReminderCardResult.displayReminderContainer
        );
      }
      const socketParams = {
        type: "reminders",
      };
      statusBoardSocketService.sendSbInputSocketParams(socketParams);
    Toast.success(t("reminderAddedSuccess"));
    } else {
      reminderService.handleErrorResponse();
      Toast.error(respReminderCardResult?.message);
    }
    setLoaderStatus(false);
  }

  const getReminderParams = () => {
    return {
      bedId: statusBoardService.rowData.id,
      statusBoardID: statusBoardService.statusBoardId,
      reg_code: utilService.getNetwork(),
    };
  };

  const isAssignedNurse = () => {
    let isAssignedNurse = false;
    const assignedNurses = statusBoardService.rowData.nurse.list_nurse;
    const loggedInUserGuid = utilService.getLoggedUserGuid();
    if (!_.isEmpty(assignedNurses)) {
      const assignedNurseObject = _.find(assignedNurses, {
        guid: loggedInUserGuid,
      });
      if (assignedNurseObject) {
        isAssignedNurse = true;
      }
    }
    return isAssignedNurse;
  };

  const addReminder = () => {
    const addParams = {
      bedId: bedID,
      nurseId: "",
      reg_code: utilService.getNetwork(),
      statusBoardID: statusBoardID,
      time: selectedTime,
      title: textData,
    };
    submitReminderCardListDetails(addParams);
  };

  // refresh the reminder list after deletion
  const refreshReminderList = (list: any) => {
    setReminderData(list);
    ReminderAlertService.reminderData = list;
    const isUserAssignedToPatient = isAssignedNurse();
    if (isUserAssignedToPatient) {
      ReminderAlertService.reminderListUpdate(list);
    }
  };

  const setInputTime = (time: any) => {
    let formattedTime =  moment(time,'HH:mm').format("hh:mm A");
    setSelectedTime(formattedTime);
  };

  return (
    <div className="sboard-reminder-container">
      <div className="sboard-reminder-wrapper">
        <div className="reminder-header-wrapper">
          <div className="reminder-heading">{t("reminders")}</div>
          <div className="add-reminder">
            <IonButton
              className={classNames({
                btn: true,
                " rounded-btn": true,
                "disable-content ":
                  statusBoardService.rowData?.pid === " " ? true : false,
              })}
              onClick={() => setShowModal(true)}
            >
              <i className="icon icon-add icon-div add-btn-icon"></i>
            <span>{t("reminder")}</span>
            </IonButton>
          </div>
        </div>

        <IonModal
          isOpen={showTimePickerModal}
          className="time-picker-modal"
          backdropDismiss={false}
        >
            <TimePicker
                getSelectedTime={(value: string) => {
                  setInputTime(value);
                }}
              ></TimePicker>
                <div className="reminder-button-container">
            <div className="send-button-div">
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  setTimePickerModal(false);
                }}
              >
                {t("add")}
              </IonButton>
            </div>
          </div>
          </IonModal>

        <IonModal
          isOpen={showModal}
          className="reminder-modal"
          backdropDismiss={false}
        >
          <div className="close-icon">
            <span
              className="input-icon icon-close"
              onClick={() => {
                setShowModal(false);
                setTextData("");
                setSelectedTime(utilService.getFormattedCurrentTime());
              }}
            ></span>
          </div>

          <div className="add-reminder-header">
           <IonLabel className="add-reminder-heading">{t("addReminder")}</IonLabel>
          </div>

          <div className="reminder-div">
          <IonLabel className="reminder-label">{t("reminder")}</IonLabel>
          </div>

          <div className="reminder-border">
            <IonInput
              id="inputSec"
              name="display"
              value={textData}
              onIonChange={(event) => setTextData(event.detail.value!)}
            ></IonInput>
          </div>

          <div className="time-div">
           <IonLabel className="time-label">{t("time")}</IonLabel>
          </div>

          <div className="reminder-border">
            <div className="select-time">
            
            <IonInput
              id="inputSec"
              name="display"
              className="selectedTimeInput"
              value={selectedTime}
              onClick={() => setTimePickerModal(true) }
              readonly
            ></IonInput>
            </div>
          </div>

          <div className="reminder-button-container">
            <div className="cancel-button-div">
              <IonButton
                color="medium"
                className="rounded-btn secondary-btn cancel-btn btn-curved"
                onClick={() => {
                  setShowModal(false);
                  setTextData("");
                  setSelectedTime(utilService.getFormattedCurrentTime());
                }}
              >
                {t("cancel")}
              </IonButton>
            </div>
            <div className="send-button-div">
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                disabled={disableAddButton}
                onClick={() => {
                  addReminder();
                  setTextData("");
                  setShowModal(false);
                }}
              >
                {t("add")}
              </IonButton>
            </div>
          </div>
        </IonModal>

        <div className="prev-notes-container">
          {reminderData && (
            <div className="notes-list-div">
              {isLoaderActive && (
                <div className="loader-container">
                  <Loader></Loader>
                </div>
              )}
              {reminderData && reminderData.length > 0 && !isLoaderActive ? (
                reminderData.map(
                  (item: displayReminderContainerModel, index: number) => {
                    return (
                      <ReminderCard
                        key={index}
                        reminderData={item}
                        refreshReminderData={refreshReminderList}
                      ></ReminderCard>
                    );
                  }
                )
              ) : (
                <span>
                  <NoResults></NoResults>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Reminder;
